import * as maplibregl from "maplibre-gl"
import $ from "jquery"
import "slick-carousel"
import {dispatchFooterChangeEvent} from "./Footer"
import {wrapPolygonLeft} from "./geojsonHelpers"
import {HistoryStateType, getPrevHistoryState, updateHistory, urlToHistoryState} from "./GlobeHistory"

let districts
/**
 * @type {maplibregl.Popup}
 */

const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
})

let init_district_id = params.district_id ?? null
let election_filter = params.election_filter ?? null
let election_type = isNaN(params.election_type) ? 0 : params.electionType ?? 0

let popup
let tutorial
let selected_vtd
let selected_lat, selected_lng
let current_district_id
let mobile_current_district_id
let selected_voting_precinct
let selected_vtd_unit
let mapControl = null

const osmServerApiHost = "/api"
const apiHost = "/api"
const today = new Date()
const start_date_obj = today
const end_date_obj = new Date(today.getTime() + 1 * 60 * 24 * 365 * 60000)

let start_date =
    start_date_obj.getFullYear() +
    "-" +
    (parseInt(start_date_obj.getMonth()) + 1) +
    "-" +
    start_date_obj.getDate()
let end_date =
    end_date_obj.getFullYear() +
    "-" +
    (parseInt(end_date_obj.getMonth()) + 1) +
    "-" +
    end_date_obj.getDate()

let selected_geo_ids
let elections = []
let precinctlist = []
let position = 0
let touched = false
let election_data_loaded = false
let initDistrict = false
let pageInitialLoading = true;

// Initialize slick carousels
// TODO: Hook into window resize to slick these
if (window.innerWidth < 991) {
    $("#districts_list").slick({
        centerMode: true,
        centerPadding: 0,
        slidesToShow: 5,
        vertical: true,
        verticalSwiping: true,
        arrows: false,
        swipeToSlide: true,
        draggable: true,
        mobileFirst: true,
        touchMove: true,
    })
    $("#elections_list").slick({
        centerMode: true,
        centerPadding: 0,
        slidesToShow: 5,
        vertical: true,
        verticalSwiping: true,
        arrows: false,
        swipeToSlide: true,
        draggable: true,
        mobileFirst: true,
        touchMove: true,
    })
}

$(".election-overview-div").show();

// Initialize election filter
function resetElectionFilter() {
    $("#year_filter_value").html("Upcoming (Next 12 months)")
    resetStartDate("upcoming")
}

function initElectionFilter() {
    if (election_filter && election_filter !== 'null') {
        $("#election_filter_dropdown").hide()
        if (election_filter == "upcoming") {
            $("#year_filter_value").html("Upcoming (Next 12 months)")
        } else if (election_filter == "past") {
            $("#year_filter_value").html("Past (Previous 12 months)")
        } else {
            if (election_filter !== "null") {
                $("#year_filter_value").text(election_filter)
            }
        }
        resetStartDate(election_filter)
    } else {
        resetElectionFilter()
    }
}

resetElectionFilter()
initElectionFilter()
if (election_type) {
    $(`.type_value[data-value="${election_type}"]`).addClass("r3-bg-primary-bg r3-text-white")
} else {
    $(`.type_value[data-value="0"]`).addClass("r3-bg-primary-bg r3-text-white")
}

class AbortManager {
    /**
     * @type {AbortController[]}
     */
    #abortables

    constructor() {
        this.#abortables = []
    }

    register() {
        const abortable = new AbortController()
        this.#abortables.push(abortable)
        return abortable
    }

    /**
     *
     * @param {AbortController} abortable
     * @returns
     */
    check(abortable) {
        return abortable.signal.aborted
    }

    /**
     *
     * @param {AbortController} abortable
     * @returns
     */
    finalCheck(abortable) {
        const index = this.#abortables.findIndex((item) => item === abortable)
        this.#abortables.splice(index, 1)
        return abortable.signal.aborted
    }

    abortAll() {
        // this.#abortables.forEach((abortable) => abortable.abort())
        handleLatLngClickAbortController.abort()
    }
}

const abortManager = new AbortManager()

export let marker

export function abortLoads() {
    // Signal every abortable to abort
    abortManager.abortAll()
}

/**
 * @type {AbortController}
 */
let handleLatLngClickAbortController = new AbortController()

export async function handleLatLngClick(lat, lng, map, options) {
    const {modifyHistory = true} = options === undefined ? {} : options
    if (marker) {
        marker.remove()
    }

    document.getElementById("right-small-panel").classList.add("active")
    document.getElementById("list_switch_container").classList.add("show")
    document.getElementById("search_bar").classList.add("right-panel-open")
    document.getElementById("center-window").classList.add("right-panel-open")

    if (pageInitialLoading) {
        $("#trans_screen_loading").show();
    }

    selected_lat = lat
    selected_lng = lng

    onStateChange({modifyHistory})

    const marker_el = document.createElement("div")
    marker_el.className = "marker"
    marker_el.style.backgroundImage = "url(/img/marker.svg)"
    marker_el.style.backgroundRepeat = "no-repeat"
    marker_el.style.backgroundPosition = "bottom"
    marker_el.style.width = "30px"
    marker_el.style.height = "50px"

    marker = new maplibregl.Marker({element: marker_el, anchor: "bottom"}).setLngLat([lng, lat]).addTo(map)

    if (pageInitialLoading) {
        $("#map .marker").addClass("!r3-hidden test");
    }

    // Abort any previous latLngClick
    handleLatLngClickAbortController.abort('clearing old lat lng click')
    handleLatLngClickAbortController = new AbortController()
    const abortable = handleLatLngClickAbortController

    if (window.innerWidth > 991) {
        $("#list_elections").html("Election Dates")
    }

    let response2
    try {
        response2 = await fetch(
            `${apiHost}/voting_precincts?lat=${lat}&lon=${lng}`, {signal: abortable.signal}
        )
    } catch (err) {
        console.warn(err, 'fetch voting precincts rejected')
        return
    }

    const data2 = await response2.json()

    // Check if aborted
    if (abortable.signal.aborted) {
        console.warn('aborted while deserializing')
        return
    }

    if (data2.status === 200) {
        console.log("response2", data2.payload)
        if (data2.payload && data2.payload.precinct && data2.payload.precinct.polling_address) {
            const precinctresult = data2.payload.precinct
            $("#view_on_google_map").show()
            if (window.innerWidth > 991) {
                $("#go-to-voting-precinct").removeClass("hidden")
                $("#districts_list").css({"maxHeight": "calc(100vh - 560px)"})
                $("#precinct_name").html(precinctresult.polling_address)
                $("#view_on_google_map").attr("href", "http://maps.google.com/?q=" + encodeURIComponent(precinctresult.polling_address))

                $(".go-to-voting-precinct-label").data("address", precinctresult.polling_address)
                $(".go-to-voting-precinct-label").data("lat", precinctresult.lat)
                $(".go-to-voting-precinct-label").data("lon", precinctresult.lon)
            } else {

                $("#go-to-voting-precinct").addClass("hidden")
                $("#precinct_name").html("")
                $("#go-to-voting-precinct").attr("href", "#")

                document.getElementById("elections_list").innerHTML = `<div class="election-item"  data-index="0">
                <div class="ballot-row-2" >
                    <div class="w-100p r3-px-4">
                        <p class="r3-px-2 r3-text-[8px] r3-text-gray-400">${precinctresult.polling_address}</p>
                        <div class="text-center r3-bg-gray-800 r3-text-white r3-px-2 r3-text-[12px] r3-py-1 r3-rounded r3-my-2 go-to-voting-precinct-label mobile-menu">View Polling Location</div>
                        <a href="${"http://maps.google.com/?q=" + encodeURIComponent(precinctresult.polling_address)}" target="_blank" class="r3-my-2 r3-text-[10px] r3-flex r3-justify-center">
                            View on Google Map
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="r3-w-3 r3-h-3 r3-ml-1">
                              <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                            </svg>
                        </a>
                    </div>
                </div>
            </div>`

                $(".go-to-voting-precinct-label.mobile-menu").data("address", precinctresult.polling_address)
                $(".go-to-voting-precinct-label.mobile-menu").data("lat", precinctresult.lat)
                $(".go-to-voting-precinct-label.mobile-menu").data("lon", precinctresult.lon)
            }
        } else {
            precinctlist = data2.payload.list
            $("#view_on_google_map").hide()

            if (window.innerWidth > 991) {
                $("#districts_list").css({"maxHeight": "calc(100vh - 455px)"})
                $("#go-to-voting-precinct").removeClass("hidden")

                $("#precinct_name").html(precinctlist.length + " addresses")
                $(".go-to-voting-precinct-label").data("address", null)
                $(".go-to-voting-precinct-label").data("lat", null)
                $(".go-to-voting-precinct-label").data("lon", null)
                $("#view_on_google_map").attr("href", "http://maps.google.com")
            }else {
                $("#go-to-voting-precinct").addClass("hidden")

                document.getElementById("elections_list").innerHTML = `<div class="election-item"  data-index="0">
                <div class="ballot-row-2" >
                    <div class="w-100p r3-px-4">
                        <div class="text-center r3-bg-gray-800 r3-text-white r3-px-2 r3-text-[12px] r3-py-1 r3-rounded r3-my-2 go-to-voting-precinct-label mobile-menu">View Polling Location</div>
                    </div>
                </div>
            </div>`

                $(".go-to-voting-precinct-label.mobile-menu").data("address", null)
                $(".go-to-voting-precinct-label.mobile-menu").data("lat", null)
                $(".go-to-voting-precinct-label.mobile-menu").data("lon", null)
            }
            $("#go-to-voting-precinct").attr("href", "#")
        }
    }
    let response
    try {
        response = await fetch(
            `${apiHost}/voting_districts?lat=${lat}&lon=${lng}`, {signal: abortable.signal}
        )
    } catch (err) {
        console.warn(err, 'fetch voting districts rejected')
        return
    }

    const data = await response.json()

    // Check if aborted
    if (abortable.signal.aborted) {
        console.warn('aborted while turning response into json')
        return
    }

    console.log("payload", data.payload)

    if (data.status === 200) {
        districts = data.payload
        if (!districts.length) return

        districts.sort((a, b) => {
            return a.order - b.order
        })

        console.log(districts)
        selected_vtd_unit = districts[0]?.district_id
        if (init_district_id) {
            selected_vtd =
                districts.find(
                    (district) => district.district_id == init_district_id
                ) || districts[0]
        } else {
            selected_vtd = districts[0]
        }
        console.log(districts)

        console.log("voting district", selected_vtd)

        renderDistricts(districts)
        showDistrict(selected_vtd, lng, lat, map, {signal: abortable.signal})
        // Pass abort signal into all of these
        getElectionByVotingDistrictIDs(getDistrictIds(districts), {signal: abortable.signal})

        // let first_new_url = updateQueryStringParameter($("#election-overview-div button.flex-row:nth-of-type(1)").attr("href"), 'zip_code', 0)
        //  first_new_url = updateQueryStringParameter(first_new_url, 'latlon', lat + ',' + lng)
        // $("#election-overview-div button.flex-row:nth-of-type(1)").attr("href", first_new_url)

        // let second_new_url = updateQueryStringParameter($("#election-overview-div button.flex-row:nth-of-type(2)").attr("href"), 'zip_code', 0)
        // second_new_url = updateQueryStringParameter(second_new_url, 'latlon', lat + ',' + lng)
        // $("#election-overview-div button.flex-row:nth-of-type(2)").attr("href", second_new_url)

        // let third_new_url = updateQueryStringParameter($("#election-overview-div button.flex-row:nth-of-type(3)").attr("href"), 'zip_code', 0)
        // third_new_url = updateQueryStringParameter(third_new_url, 'latlon', lat + ',' + lng)
        // $("#election-overview-div button.flex-row:nth-of-type(3)").attr("href", third_new_url)

        return data
    }

}

class OSMMapControl {
    #listeners
    #map
    #handleEvent

    constructor(map) {
        this.#listeners = []
        this.#map = map
        this.#handleEvent = false
    }

    #ondblclick(e) {
        e.preventDefault()
        handleOnMapEvent(e, this.#map)
    }

    #ontouchend(e) {
        if (this.#handleEvent) handleOnMapEvent(e, this.#map)
        return false
    }

    #ontouchstart() {
        this.#handleEvent = true
        return false
    }

    #ontouchmove(e) {
        this.#handleEvent = false
        return false
    }

    #addHandler(name, handler) {
        this.#listeners.push([name, handler])
        this.#map.on(name, handler)
    }

    attach() {
        this.#addHandler("dblclick", (e) => this.#ondblclick(e))
        this.#addHandler("touchend", (e) => this.#ontouchend(e))
        this.#addHandler("touchstart", (e) => this.#ontouchstart(e))
        this.#addHandler("touchmove", (e) => this.#ontouchmove(e))
    }

    detach() {
        this.#listeners.forEach((listener) => {
            this.#map.off(...listener)
        })
    }
}


function clickSaveVotingPrecinctBtn() {

    if (getCookie('user_id')) {

        let search = window.location.search;

        search = search.replace(/&election_filter=\d+-?\d*&?/, '&');
        if (search.endsWith('&')) {
            search = search.slice(0, -1);
        }

        let data = {
            district_id: selected_vtd_unit,
            city: selected_voting_precinct.city ?? null,
            county: selected_voting_precinct.county ?? null,
            lat: selected_voting_precinct.lat ?? null,
            lon: selected_voting_precinct.lon ?? null,
            formatted: selected_voting_precinct.formatted ?? null,
            state: selected_voting_precinct.state ?? null,
            street: selected_voting_precinct.street ?? null,
            zip: selected_voting_precinct.zip ?? null,
            url: window.location.pathname + search
        }

        saveMyVotingPrecinct(data)

        $("#confirm_voting_precinct_modal").fadeOut();
        $("#save_location_btn").remove();
        $("#save-my-voting-precinct-label").html(
            "My Voting Precinct"
        )

        if (window.flutter_inappwebview) {
            window.flutter_inappwebview.callHandler('saveMyVotingPrecinct', data.url)
        }

    } else displayLogin();
}

export function enableOSMUIControls(map) {
    mapControl = new OSMMapControl(map)
    mapControl.attach()

    let following_blank_elections = [];

    if (getCookie('user_id')) {
        api.get('elections/following')
            .then(response => {
                return response.json();
            }).then(data => {
            following_blank_elections = data.payload.blank_elections;
            console.log("blanks", following_blank_elections)
        })
            .catch(function (error) {
            });
    }

    $(".election-overview-div").removeClass("hidden")

    // $(".type_value").on("click.osm", function (e) {
    //     if ($(this).hasClass("disabled")) {
    //         e.preventDefault();
    //         return false;
    //     }
    //     const type = $(this).data("value")
    //     $(this).siblings().removeClass('r3-bg-primary-bg r3-text-white')
    //     $(this).addClass('r3-bg-primary-bg r3-text-white')
    //     election_type = type
    //     onStateChange({modifyHistory: true})
    //     getElectionByVotingDistrictIDs()
    //
    //     if (type == 2) {
    //         $("#year_filter_dropdown .election-filter-option").addClass("disabled")
    //         $("#year_filter_dropdown .election-filter-option[data-value='2027']").removeClass("disabled")
    //         $("#year_filter_dropdown .election-filter-option[data-value='2026']").removeClass("disabled")
    //         $("#year_filter_dropdown .election-filter-option[data-value='2025']").removeClass("disabled")
    //         $("#year_filter_dropdown .election-filter-option[data-value='2024-2']").removeClass("disabled")
    //     } else {
    //         $("#year_filter_dropdown .election-filter-option").removeClass("disabled")
    //     }
    // })

    $(".year_value").on("click.osm", function (e) {
        if ($(this).hasClass("disabled")) {
            e.preventDefault();
            return false;
        }

        const year = $(this).data("value")
        $("#year_filter_value").html($(this).html())
        $("#year_filter_dropdown").hide()
        resetStartDate(year)
        election_filter = year
        onStateChange({modifyHistory: true})
        getElectionByVotingDistrictIDs()

        if (year == '2027' || year == '2026' || year == '2025' || year == '2024') {
            $("#type_filter_dropdown .election-filter-option").removeClass("disabled")

        } else {
            $("#type_filter_dropdown .election-filter-option[data-value='2']").addClass("disabled")

        }
    })

    $("#left-panel").on("click.osm", function () {
        $(".election-filter-options-list").slideUp()
    })

    $(window).on("click.osm", function () {
        $(".election-filter-options-list").slideUp()
    })

    $(".election-filter-dropdown-selector").on("click.osm", function (e) {
        e.stopPropagation()
        if (!election_data_loaded) return;

        const target = $(this).data("target")
        $($(this).data("target")).slideToggle()
        $(".election-filter-options-list:not(" + target + ")").slideUp()
    })

    $("#districts_list").on(
        "afterChange.osm",
        function (event, slick, currentSlide) {
            const index = currentSlide % districts.length
            if (!index) return
            showDistrict(districts[index], null, null, map)
        }
    )

    $(document).on("click.osm", ".district_item", function (e) {
        if ($(this).hasClass("active")) return

        if (window.innerWidth < 991) {
            $("#map-arrow").click()

            const index = $(this).data("index")
            if ($(".slick-center.district_item").data("index") == index) return
            $(".district_item").removeClass("slick-center")
            $(".district_item[data-index=" + index + "]").addClass("slick-center")
            $("#districts_list").animate(
                {
                    scrollTop: index == 0 ? 0 : (index - 1) * 32,
                },
                150
            )
        }
        $(".district_item").removeClass("active")
        $(this).addClass("active")
        const index = $(this).data("index")
        // if (window.innerWidth < 991) {
        //     const clickedIndex = $(this).data("slick-index")
        //     $("#districts_list").slick("slickGoTo", clickedIndex)
        // }

        selected_vtd = districts[index]

        onStateChange({modifyHistory: true})

        showDistrict(selected_vtd, null, null, map)
    })

    $(document).on("click.osm", ".election-item", function () {
        if (window.innerWidth < 991) {
            const index = $(this).data("index")
            if ($(".slick-center.election-item").data("index") == index) return
            $(".election-item").removeClass("slick-center")
            $(".election-item[data-index=" + index + "]").addClass(
                "slick-center"
            )
            $("#elections_list").animate(
                {
                    scrollTop: index == 0 ? 0 : (index - 1) * 26,
                },
                150
            )

            const district_id = $(this).data("district")
            if (mobile_current_district_id != district_id) {
                mobile_current_district_id = district_id
                $(
                    `#districts_list .district_item[data-id=${mobile_current_district_id}]`
                ).click()
            }
        }
    })

    $(document).on("click.osm", ".go-to-voting-precinct-label", async function (e) {
        let address = $(this).data("address")
        let lat = $(this).data("lat")
        let lon = $(this).data("lon")

        console.log(address, lat, lon)

        if(address)
        {
            showPrecinctMarker(address, map, lon, lat)
        }else {
            if(precinctlist.length)
            {
                let modalContent = `
                        <div class="modal-content r3-fixed r3-inset-0 r3-bg-black/50 r3-flex r3-items-center r3-justify-center">
                            <div class="r3-bg-white r3-rounded-lg r3-w-[640px] r3-mx-4">
                                <div class="r3-relative r3-py-4 r3-px-4 md:r3-px-8">
                                    <button type="button" class="cancel_polling_location_list_modal_btn r3-absolute r3-right-4 r3-top-4">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="r3-w-6 r3-h-6">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                    </button>
                                    
                                    <div class="r3-text-center r3-mb-6">
                                        <h2 class="r3-text-xl r3-font-medium r3-mb-2">There are ${precinctlist.length} voting precinct locations</h2>
                                        <p class="r3-text-gray-600">Currently available data shows the address of your local polling locations. <br>Our team is working hard to collect your local voting precinct maps. Please reach out to your local election office for your official voting location. </p>
                                    </div>
                    
                                    <div class="r3-space-y-3 r3-max-h-[280px] md:r3-max-h-[480px] r3-overflow-y-auto">
                                        ${precinctlist.map(precinct => `
                                            <div class="precinct-item r3-p-4 r3-border r3-border-gray-200 r3-rounded r3-cursor-pointer hover:r3-bg-gray-50" 
                                                data-address="${precinct.address}"
                                                data-district="${precinct.district}"
                                                data-id="${precinct.id}">
                                                <div class="r3-flex r3-items-center r3-gap-3">
                                                    <div style="padding: 5px">
                                                        <img src="/assets/voting_precinct.webp" style="width: 40px"/>
                                                    </div>
                                                    <div class="r3-flex-1 r3-text-sm r3-text-gray-600">${precinct.address}</div>
                                                    <a href="http://maps.google.com/?q=${encodeURIComponent(precinct.address)}" target="_blank" class="r3-text-sm r3-text-gray-600 hover:r3-text-gray-950 r3-flex r3-items-center r3-gap-1">
                                                            <span class="r3-hidden md:r3-inline-block">Google Map</span>
                                                            <svg title="View on Google Map" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="r3-w-3 r3-h-3 r3-ml-1">
                                                                <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                                                            </svg>
                                                        </a>
                                                </div>
                                            </div>
                                        `).join('')}
                                    </div>
                                </div>
                            </div>
                        </div>
                    `
                // Show modal
                $("#polling_location_list_modal").html(modalContent).show()
            }else {
                $("#polling_location_modal").show();
            }
        }


    })

    $("#districts_list")
        .on("touchstart.osm", function () {
            position = $("#districts_list").scrollTop()
            touched = true
        })
        .on("touchmove.osm", function () {
            if (touched) {
                // $("#districts_list").css("paddingTop", "32px")
                // $("#districts_list").css("paddingBottom", "32px")
                $("#districts_list").scrollTop(position + 32)
                touched = false
            }
            const currentPosition = $("#districts_list").scrollTop()
            let index = Math.round(currentPosition / 32)
            if (index >= elections.length) index = elections.length - 1
            if (index < 0) index = 0
            $(".district_item").removeClass("slick-center")
            $(".district_item[data-index=" + index + "]").addClass(
                "slick-center"
            )
        })
        .on("touchend.osm", function () {
            $("#districts_list").css("paddingTop", 0)
            $("#districts_list").css("paddingBottom", 0)
            const index = $(".district_item.slick-center").data("index")
            // $("#districts_list").animate(
            //     {
            //         scrollTop: index == 0 ? 0 : (index - 1) * 32,
            //     },
            //     300
            // )

            selected_vtd = districts[index]

            showDistrict(selected_vtd, null, null, map)
        })

    $("#elections_list")
        .on("touchstart.osm", function () {
            position = $("#elections_list").scrollTop()
            touched = true
        })
        .on("touchmove.osm", function () {
            if (touched) {
                $("#elections_list").css("paddingTop", "26px")
                $("#elections_list").css("paddingBottom", "26px")
                $("#elections_list").scrollTop(position + 26)
                touched = false
            }
            const currentPosition = $("#elections_list").scrollTop()
            let index = Math.round(currentPosition / 26)
            if (index >= elections.length) index = elections.length - 1
            if (index < 0) index = 0
            $(".election-item").removeClass("slick-center")
            $(".election-item[data-index=" + index + "]").addClass(
                "slick-center"
            )
        })
        .on("touchend.osm", function () {
            $("#elections_list").css("paddingTop", 0)
            $("#elections_list").css("paddingBottom", 0)
            const index = $(".election-item.slick-center").data("index")
            $("#elections_list").animate(
                {
                    scrollTop: index == 0 ? 0 : (index - 1) * 26,
                },
                300
            )
        })

    $(window).on("click.osm", function () {
        document.getElementById("left-panel").classList.remove("active")
    })

    $(document).on("click.osm", "#left-panel", function (e) {
        e.stopPropagation()
    })

    $(document).on("click.osm", ".list_switch_container", function (e) {
        e.stopPropagation()

        if (window.innerWidth > 991) $("#elections_list").show()
        else {
            // if (document.getElementById("list_elections").classList.contains("no-elections")) {
            //     displayNoPollingLocation()
            // } else {
            //     $(".list_switch_container").toggleClass("active")
            //     $("#elections_list").toggle()
            //     $("#districts_list").hide()
            //     $(".district_container").removeClass("active")
            //     $("#elections_list").slick("resize")
            // }
            $(".list_switch_container").toggleClass("active")
            $("#elections_list").toggle()
            $("#districts_list").hide()
            $(".district_container").removeClass("active")
            $("#elections_list").slick("resize")
        }
    })

    $(document).on("click.osm", ".district_container", function (e) {
        e.stopPropagation()

        if (window.innerWidth > 991) $("#districts_list").show()
        else {
            $(".district_container").toggleClass("active")
            $("#districts_list").toggle()
            $("#elections_list").hide()
            $(".list_switch_container").removeClass("active")
            $("#districts_list").slick("resize")
            $("#districts_list").slick("slickGoTo", length)
            if (initDistrict) {
                $("#districts_list").animate(
                    {
                        scrollTop: 0,
                    },
                    150
                )
                initDistrict = false
            }
        }
    })

    $(document).on("click.osm", "#map-arrow", function (e) {
        e.stopPropagation()

        if ($(".election-list").hasClass("hide"))
            $(".election-list").removeClass("hide")
        else $(".election-list").addClass("hide")
    })

    $("#save-my-voting-precinct").on("click.osm", function () {
        $("#confirm_voting_precinct_modal").fadeIn();
    })

    $(document).on("click.osm", ".go_to_my_election", function (e) {
        const type = $(this).data("type")

        let url = `/pages/my-elections?type=${type}&election_filter=${election_filter}&start_date=${start_date}&end_date=${end_date}&district_id=${selected_geo_ids}&election_type=${election_type}`;

        if (e.ctrlKey || e.which == 2 || e.button == 4) {
            window.open(url, '_blank')
        } else {
            window.location.href = url
        }
    })

    $(document).on("click.osm", ".election-item .election-link", function () {


        if ($(this).data("blank") == 1) {
            let election_date = $(this).data("date");
            console.log(election_date)
            if (election_date) {
                let today = (new Date()).toISOString().split('T')[0];
                console.log('is past', election_date < today);

                if (election_date < today) {
                    $("#blank_election_modal .modal-title").text("Past Election");
                    $("#blank_election_modal .modal-text").text("Due to different stages of development, some past election data is not available at this time.");
                } else {
                    $("#blank_election_modal .modal-title").text("Up for Election");
                    $("#blank_election_modal .modal-text").html('We are continuing to gather candidate information for this election.Candidate information can become available as close as 30 days prior to the election. <br><br>Please check back soon.<br><br>Click the "Follow" button to get notifications as candidates are added to this election.');
                }
            } else {
                $("#blank_election_modal .modal-title").text("No Election Data");
                $("#blank_election_modal .modal-text").text("There is no data for this election.");
            }
            $("#blank_election_modal").show();
            const follow_btn = $("#follow_blank_election_modal_btn");
            const id = $(this).data("id");
            follow_btn.data("id", id);
            const alreadyFollowing = following_blank_elections.some(element => element == id);
            follow_btn.data("action", alreadyFollowing ? "unfollow" : "follow");
            follow_btn.text(alreadyFollowing ? "Unfollow" : "Follow");
            return;
        }


        const link = $(this).data("href")
        if (!link) return

        if ($(this).data("subdistricted") == 1) {

            const index = $(this).data("index")
            const electionIndex = $("#elections_list .slick-center").data("index")
            if (index !== electionIndex) return

            window.location.href = link
        } else {
            $("#prioritize_location_id").val($(this).data("location"))
            $("#prioritize_my_area").data("link", link)
            $("#confirm_subdistrict_modal").show();
        }

    })
    $(document).on("click.osm", ".cancel_subdistrict_modal_btn", function (e) {
        e.preventDefault();
        $("#confirm_subdistrict_modal").hide();
    })
    $(document).on("click.osm", ".cancel_blank_election_modal_btn", function (e) {
        e.preventDefault();
        $("#blank_election_modal").hide();
    })
    $(document).on("click.osm", ".cancel_polling_location_modal_btn", function (e) {
        e.preventDefault();
        $("#polling_location_modal").hide();
    })
    $(document).on("click.osm", ".cancel_polling_location_list_modal_btn", function (e) {
        e.preventDefault();
        $("#polling_location_list_modal").hide();
    })
    $(document).on("click.osm", ".cancel_canceled_election_modal_btn", function (e) {
        e.preventDefault();
        $("#canceled_election_modal").hide();
    })
    $(document).on("click.osm", "#follow_blank_election_modal_btn", function (e) {
        e.preventDefault();
        let election_id = $(this).data("id")
        let action = $(this).data("action")
        if (getCookie('user_id')) {
            if (action === 'follow') {
                api.put('election/0' + election_id + '/follow')
                    // .then(response => response.json())
                    .then(function (response) {
                        customAlert('You are now following this election!', () => {
                            window.location.reload();
                        });
                    })
                    .catch(function (error) {
                    });
            } else {
                api.delete('/election/0' + election_id + '/follow')
                    .then(function (response) {
                        customAlert('You have unfollowed this election!', () => {
                            window.location.reload();
                        });
                    })
                    .catch(function (error) {
                    });
            }
        } else {
            $("#blank_election_modal").hide();
            customAlert('Please log in or create a free account to access this feature!', () => {
                displayLogin();
                $('.popup.login form').attr('action', 'javascript:userLogin(".login", "' + window.location.href + '")');    // Redirect to current page upon login
            });
        }
    })
    $(document).on("click.osm", "#prioritize_my_area", function (e) {
        e.preventDefault();
        let location_id = $("#prioritize_location_id").val()
        let link = $(this).data("link")

        api.post("user/prioritize/" + location_id + "/location").then(function (response) {
            window.location.href = link
        })
    })

    $(document).on("click.osm", ".election_candidate_a", function (e) {
        e.preventDefault()
        if ($(this).data("blank") == 1) {
            console.log(response_elections)
            let blank_election = response_blank_elections.find(x => x.id == $(this).data("id"))

            let election_date = $(this).data("date");
            console.log('election date: ', election_date)
            if (election_date) {
                let today = (new Date()).toISOString().split('T')[0];
                console.log('is past', election_date < today);

                if (election_date < today) {
                    $("#blank_election_modal .modal-title").text("Past Election");
                    $("#blank_election_modal .modal-text").text("Due to different stages of development, some past election data is not available at this time.");
                } else {
                    $("#blank_election_modal .modal-title").text("Up for Election");
                    $("#blank_election_modal .modal-text").html('We are continuing to gather candidate information for this election.Candidate information can become available as close as 30 days prior to the election. <br><br>Please check back soon.<br><br>Click the "Follow" button to get notifications as candidates are added to this election.');
                }
            } else {
                $("#blank_election_modal .modal-title").text("No Election Data");
                $("#blank_election_modal .modal-text").text("There is no data for this election.");
            }
            
            if (!blank_election) {
                $("#blank_election_modal").show();
                const follow_btn = $("#follow_blank_election_modal_btn");
                const id = $(this).data("id");
                follow_btn.data("id", id);
                const alreadyFollowing = following_blank_elections.some(element => element == id);
                follow_btn.data("action", alreadyFollowing ? "unfollow" : "follow");
                follow_btn.text(alreadyFollowing ? "Unfollow" : "Follow");
                return;
            }
            console.log(blank_election)
            if (blank_election.is_canceled == "1") {
                $("#canceled_election_modal").show();

                return;
            }

            let filtered_elections_by_blank;

            if (blank_election.government_level_id == 3 && blank_election.election_name.includes("President")) {
                filtered_elections_by_blank = response_elections.filter(x => (x.government_level_id == 3 && x.branch_id == 1 && x.election_type_id == blank_election.election_type_id && x.election_date.substring(0, 4) == blank_election.election_date.substring(0, 4)))
            } else {
                filtered_elections_by_blank = response_elections.filter(x => (x.government_level_id == blank_election.government_level_id && x.election_type_id == blank_election.election_type_id && x.election_date.substring(0, 7) == blank_election.election_date.substring(0, 7)))
            }
            if (!filtered_elections_by_blank.length) {
                $("#blank_election_modal").show();
                const follow_btn = $("#follow_blank_election_modal_btn");
                const id = $(this).data("id");
                follow_btn.data("id", id);
                const alreadyFollowing = following_blank_elections.some(element => element == id);
                follow_btn.data("action", alreadyFollowing ? "unfollow" : "follow");
                follow_btn.text(alreadyFollowing ? "Unfollow" : "Follow");
                return;
            }
            // if(filtered_elections_by_blank.length == 1) {
            //     window.location.href = "/pages/election-candidates/index.php?election_id=" + filtered_elections_by_blank[0].election_id;
            //     return;
            // }
            // if
            // let type;
            // if (blank_election.government_level_id == 1) {
            //     type = 'local'
            // } else if (blank_election.government_level_id == 2) {
            //     type = 'state'
            // } else {
            //     type = 'federal'
            // }

            let url = `/pages/my-elections?election_filter=${election_filter}&start_date=${start_date}&end_date=${end_date}&district_id=${selected_geo_ids}&election_type=${election_type}&election_date=${blank_election.election_date}#grid${blank_election.election_date}`

            if (e.ctrlKey || e.which == 2 || e.button == 4) {
                window.open(url, '_blank')
            } else {
                window.location.href = url
            }
            return;
        }
        const link = $(this).attr("href")
        if (!link) return
        if ($(this).data("subdistricted") == 1) {
            if (e.ctrlKey || e.which == 2 || e.button == 4) {
                window.open(link, '_blank')
            } else {
                window.location.href = link
            }
        } else {
            $("#prioritize_location_id").val($(this).data("location"))
            $("#prioritize_my_area").data("link", link)
            $("#confirm_subdistrict_modal").show();
        }
    })

    $(document).on("mouseover.osm", ".election_candidate_a", function (e) {
        const district_id = $(this).data("district")
        if (current_district_id != district_id) {
            current_district_id = district_id
            $(
                `#districts_list .district_item[data-id=${current_district_id}]`
            ).trigger("click")
        }
    })
}

function onStateChange(options) {
    console.log('onStateChange')
    const {modifyHistory = true} = options
    if (modifyHistory) {
        const prevState = getPrevHistoryState()
        const state = {
            type: HistoryStateType.map,
            lon: selected_lng,
            lat: selected_lat,
            usCounty: history.state.usCounty,
            usState: history.state.usState,
            districtId: selected_vtd ? selected_vtd.district_id : null,
            electionFilter: election_filter,
            electionType: election_type,
        }

        let newUrl = updateQueryStringParameter(
            window.location.href,
            "lng",
            selected_lng
        )
        newUrl = updateQueryStringParameter(newUrl, "lat", selected_lat)
        newUrl = updateQueryStringParameter(
            newUrl,
            "district_id",
            selected_vtd ? selected_vtd.district_id : null
        )
        newUrl = updateQueryStringParameter(
            newUrl,
            "election_filter",
            election_filter
        )
        newUrl = updateQueryStringParameter(newUrl, "election_type", election_type)

        updateHistory(state)
    }
}

function disableOSMUIControls() {
    $("#elections_list").off(".osm")
    $(".type_value").off(".osm")
    $(".year_value").off(".osm")
    $("#left-panel").off(".osm")
    $(".election-filter-dropdown-selector").off(".osm")
    $("#save-my-voting-precinct").off(".osm")
    $("#districts_list").off(".osm")
    $(document).off(".osm")
    $(window).off(".osm")
    mapControl?.detach()
}

/**
 * To Do a full reset, make sure to call OSMMapControls.detach()
 */
export function reset(map) {
    popup?.remove()
    marker?.remove()
    disableOSMUIControls()
    const polygonSource = map.getSource("polygon")
    if (polygonSource) {
        map.removeLayer("polygon")
        map.removeSource("polygon")
    }
    // Hide right panel
    $("#right-small-panel").removeClass("active")
    $("#list_switch_container").removeClass("show")
    // Don't empty district list in mobile UI, as it breaks slick
    // TODO: Figure out a way to work with slick
    if (window.innerWidth >= 991) {
        $("#districts_list").empty()
    }
    // Remove election counts
    $(".go_to_my_election .num").empty()
    // Hide save my voting precinct button
    document.querySelector("#save-my-voting-precinct").classList.add("hidden")

    abortLoads()
    $("#trans_screen_loading").hide();
}

export function setTutorial(tut) {
    tutorial = tut
}

let another_marker;

async function showPrecinctMarker(address, map, lon = null, lat = null) {

    if (another_marker) {
        another_marker.remove()
    }
    const marker_el = document.createElement("div")
    marker_el.className = "marker2"
    marker_el.style.backgroundImage = "url(/img/voting_precinct.svg)"
    marker_el.style.backgroundRepeat = "no-repeat"
    marker_el.style.backgroundPosition = "bottom"
    marker_el.style.width = "30px"
    marker_el.style.height = "50px"
    if (!lat || !lon) {

        let locationResult = await api.get("search/address?q=" + encodeURIComponent(address));
        locationResult = await locationResult.json()
        let locationData = locationResult.payload
        //
        // let locationResult = await fetch("https://api.geocod.io/v1.7/geocode?q=" + encodeURIComponent(address) + "&api_key=6c8c5dd680c66dfed667da6d6765aee5e800a7d&limit=3&country=US")
        // let locationData = await locationResult.json()

        lat = locationData.results[0].location.lat
        lon = locationData.results[0].location.lng

        // let address_components = locationData.results[0].address_components?? null
        //
        // let county = address_components.county.replace(" County", "")
        // let usState = address_components.state

    }

    another_marker = new maplibregl.Marker({element: marker_el, anchor: "bottom"}).setLngLat([lon, lat]).addTo(map)

    window.smoothlyGoToViewPoint(lat, lon, 13.24)
}

$(document).on("click", "#save_location_btn", function (e) {
    $("#confirm_voting_precinct_modal").fadeIn();
})
$(document).on("click", "#save_precinct_btn", function (e) {
    e.preventDefault();
    clickSaveVotingPrecinctBtn();
})
$(document).on("click", ".cancel_precinct_btn", function (e) {
    e.preventDefault();
    $("#confirm_voting_precinct_modal").fadeOut();
})

function fixPolygonWithInnerRingsThatShouldTheExteriorRingsOfSeparatePolygonsInAMultiPolygon(
    polygon
) {
    return {
        type: "MultiPolygon",
        coordinates: [...polygon.coordinates.map((coord) => [coord])],
    }
}

/**
 * Options for ShowDistrict
 * @typedef {{signal?: AbortSignal}} ShowDistrictOptions
 */
/**
 *
 * @param {*} vtd
 * @param {*} lng
 * @param {*} lat
 * @param {*} map
 * @param {ShowDistrictOptions} [options]
 * @returns
 */
function showDistrict(vtd, lng, lat, map, options) {
    /**
     * @type {AbortSignal | undefined}
     */
    let signal
    if (options !== undefined) {
        ;({signal} = options)
    }
    if (!vtd) return;

    const displayName = getDistrictName(vtd) + vtd.location_name

    if (!popup) {
        popup = new maplibregl.Popup({
            anchor: "bottom",
            offset: {bottom: [0, -20]},
            closeButton: false,
            closeOnClick: false,
            className: "pb28",
        }).addTo(map)
    } else if (!popup.isOpen()) {
        popup.addTo(map)
    }
    if (lng && lat) {
        popup.setLngLat([lng, lat])
    }
    console.log("my_vtd_lat/my_vtd_lon", [my_vtd_lat, my_vtd_lon])
    console.log("lat/lon", [lat, lng])
    // DOM Mutation
    if (lat && lng) {


        if (my_vtd_lat && my_vtd_lon && my_vtd_lat.toFixed(8) == lat.toFixed(8) && my_vtd_lon.toFixed(8) == lng.toFixed(8)) {
            $("#save-my-voting-precinct-label").html(
                "My Voting Precinct"
            )

            popup.setHTML(`<h1>${displayName}</h1>`);
        } else {
            $("#save-my-voting-precinct-label").html(
                "Save As My Voting Precinct"
            )

            popup.setHTML(`<h1>${displayName}</h1><div class="r3-cursor-pointer r3-border r3-border-solid r3-w-full r3-px-2 r3-py-0 r3-border-primary-dark-grey10 r3-rounded r3-mt-2 r3-flex r3-justify-between r3-items-center" id="save_location_btn">Save Location <input type="radio" class="r3-ml-1"></div>`);

        }

        if (pageInitialLoading) {
            $("#map .maplibregl-popup").addClass("!r3-hidden osm_popup");
            pageInitialLoading = false;
        }


        api.get(`geocode/geoapify-reverse?lat=${parseFloat(lat)}&lon=${parseFloat(lng)}`)
            .then((response) => response.json())
            .then(async (result) => {
                selected_voting_precinct = result.features[0].properties ?? null;

                api.get(`geocode/geocodio-reverse?lat=${parseFloat(lat)}&lon=${parseFloat(lng)}`)
                    .then((response) => response.json())
                    .then((result2) => {
                        console.log("result2", result2);
                        const resultItem = result2.results[0];
        
                        let address_components = resultItem.address_components;
                        address_components.county = address_components.county.replace(" County", "");
                        selected_voting_precinct.zip = address_components.zip ?? '';
                        selected_voting_precinct = address_components;
                        selected_voting_precinct.lat = parseFloat(lat);
                        selected_voting_precinct.lon = parseFloat(lng);
                        selected_voting_precinct.formatted = resultItem.formatted_address;
        
                        console.log("selected_voting_precinct", selected_voting_precinct);
                        document.getElementById("vtd_name").innerText = resultItem.formatted_address;
                    })
                    .catch(err => {
                        console.warn(err)
                    })
            })
            .catch(err => {
                console.warn(err);
            });
    }
    // document.getElementById("vtd_name").innerText = displayName

    const polygonSource = map.getSource("polygon")
    let polygon = JSON.parse(vtd.polygon)
    if (polygon.coordinates.length > 1) {
        polygon =
            fixPolygonWithInnerRingsThatShouldTheExteriorRingsOfSeparatePolygonsInAMultiPolygon(
                polygon
            )
    }
    if (polygonSource) {
        map.removeLayer("polygon")
        map.removeSource("polygon")
    }
    try {
        map.addSource(`polygon`, {
            type: "geojson",
            data: {
                type: "Feature",
                geometry: polygon,
            },
        })

        map.addLayer({
            id: `polygon`,
            type: "fill",
            source: `polygon`,
            layout: {},
            paint: {
                "fill-color": "#FFFFFF",
                // 'fill-color': '#A7A9AC',
                "fill-opacity": 0.5,
            },
        })
    } catch (e) {
        console.log(e)
    }
}

function getDistrictName(district) {
    if (district.type_id == 1) {
        if (isInt(district.name)) {
            return "District " + district.name + ", "
        } else {
            return district.name + ", "
        }
    } else {
        return ""
    }
}

function handleOnMapEvent(e, map) {
    // tutorial.state.send("SELECT_HOME")
    const {lng, lat} = e.lngLat
    initDistrict = true
    handleLatLngClick(lat, lng, map)
}

function updateQueryStringParameter(uri, key, value) {
    const re = new RegExp("([?&])" + key + "=.*?(&|$)", "i")
    const separator = uri.indexOf("?") !== -1 ? "&" : "?"
    if (uri.match(re)) {
        return uri.replace(re, "$1" + key + "=" + value + "$2")
    } else {
        return uri + separator + key + "=" + value
    }
}

function isInt(value) {
    return (
        !isNaN(value) &&
        parseInt(Number(value)) == value &&
        !isNaN(parseInt(value, 10))
    )
}

// Inspection point

function resetStartDate(year = null) {
    year = year.toString()
    let start_date_obj, end_date_obj
    switch (year) {
        case "2027":
            start_date = "2027-01-01"
            end_date = "2027-12-31"
            break
        case "2026":
            start_date = "2026-01-01"
            end_date = "2026-12-31"
            break
        case "2025":
            start_date = "2025-01-01"
            end_date = "2025-12-31"
            break
        case "upcoming":
            start_date_obj = today
            end_date_obj = new Date(today.getTime() + 1 * 60 * 24 * 365 * 60000)

            start_date =
                start_date_obj.getFullYear() +
                "-" +
                (parseInt(start_date_obj.getMonth()) + 1) +
                "-" +
                start_date_obj.getDate()
            end_date =
                end_date_obj.getFullYear() +
                "-" +
                (parseInt(end_date_obj.getMonth()) + 1) +
                "-" +
                end_date_obj.getDate()
            break
        case "past":
            start_date_obj = new Date(today.getTime() - 1 * 60 * 24 * 365 * 60000)
            end_date_obj = new Date(today.getTime() - 24 * 60 * 60 * 1000)

            start_date =
                start_date_obj.getFullYear() +
                "-" +
                (parseInt(start_date_obj.getMonth()) + 1) +
                "-" +
                start_date_obj.getDate()

            end_date =
                end_date_obj.getFullYear() +
                "-" +
                (parseInt(end_date_obj.getMonth()) + 1) +
                "-" +
                end_date_obj.getDate()
            break
        case "2024":
            start_date = "2024-01-01"
            end_date = "2024-12-31"
            break
        case "2023":
            start_date = "2023-01-01"
            end_date = "2023-12-31"
            break
        case "2022":
            start_date = "2022-01-01"
            end_date = "2022-12-31"
            break
        case "2021":
            start_date = "2021-01-01"
            end_date = "2021-12-31"
            break
        case "2020":
            start_date = "2020-01-01"
            end_date = "2020-12-31"
            break
        case "2019":
            start_date = "2019-01-01"
            end_date = "2019-12-31"
            break
        case "2018":
            start_date = "2018-01-01"
            end_date = "2018-12-31"
            break
        default:
            start_date_obj = today
            end_date_obj = new Date(today.getTime() + 1 * 60 * 24 * 365 * 60000)

            start_date =
                start_date_obj.getFullYear() +
                "-" +
                (parseInt(start_date_obj.getMonth()) + 1) +
                "-" +
                start_date_obj.getDate()
            end_date =
                end_date_obj.getFullYear() +
                "-" +
                (parseInt(end_date_obj.getMonth()) + 1) +
                "-" +
                end_date_obj.getDate()
    }
    console.log(start_date, end_date)
}

function getGovernmentLevelImg(level) {
    if (level === "Local") {
        return `<img src="/assets/ballotBoxL.webp" class="election_img">`
    } else if (level === "State") {
        return `<img src="/assets/ballotBoxS.webp" class="election_img">`
    } else if (level === "Federal") {
        return `<img src="/assets/ballotBoxF.webp" class="election_img">`
    } else {
        return `<img src="/assets/ballotBoxA.png" class="election_img">`
    }
}

function getDistrictIds(districts) {
    if (!districts.length) return ""
    const ids = []
    districts.map((district, index) => {
        ids.push(district.district_id)
    })
    return ids.join()
}

function getDistrictImage(type) {
    if (["Congressional House District"].includes(type)) {
        return `<img src="/assets/ballotBoxF.webp" class="district_img">`
    } else if (
        [
            "State Legislative Lower District",
            "State Legislative Upper District",
            "State District",
        ].includes(type)
    ) {
        return `<img src="/assets/ballotBoxS.webp" class="district_img">`
    } else {
        return `<img src="/assets/ballotBoxL.webp" class="district_img">`
    }
}

function renderDistricts(districts) {
    $(".election-list").show()
    if (window.innerWidth < 991) {
        $("#districts_list").hide()
        $("#elections_list").hide()
        $(".district_container").removeClass("active")
        $(".list_switch_container").removeClass("active")
    } else {
        $("#districts_list").show()
        $(".election-list").removeClass("hide")
    }

    // if (window.innerWidth < 600) {
    //     $('#districts_list').slick('removeSlide', null, null, true);
    //     $("#districts_list").slick('unslick')
    //     $("#districts_list").slick({
    //         centerMode: true,
    //         centerPadding: 0,
    //         slidesToShow: 3,
    //         vertical: true,
    //         verticalSwiping: true,
    //         arrows: false,
    //         swipeToSlide: true,
    //         infinite: true,
    //         initialSlide: 0
    //     });
    // }
    let districts_list = ""
    districts.map((district, index) => {
        let active
        if (init_district_id) {
            active = district.district_id == init_district_id
        } else {
            active = index == 0
        }

        if (window.innerWidth < 991) {
            districts_list += `<div class="district_item ballot-row-2 ${
                active ? "active" : ""
            } ${!index ? "slick-center" : ""}" data-index="${index}">
            <div class="img-election-type">
                ${getDistrictImage(district.type)}
            </div>
            <div class="w-100p">
                <p class="election-name-cls">${getDistrictName(district)} ${
                district.location_name
            }</p>
                <div class="district-box">
                    <p class="election-label-gray text-left">Type</p>
                    <p class="district-type">${district.type}</p>
                </div>
            </div>
        </div>`
        } else {
            districts_list += `<div>
                <a  href="javascript:void(0);" class="district_item ballot-row-2 ${
                active ? "active" : ""
            }" data-index="${index}" data-id="${district.district_id}">
                    <div class="img-election-type">
                    ${getDistrictImage(district.type)}
                    </div>
                    <div class="w-100p">
                        <p class="election-name-cls">${getDistrictName(
                district
            )} ${district.location_name}</p>
                        <div class="district-box">
                            <p class="election-label-gray text-left">Type</p>
                            <p class="district-type">${district.type}</p>
                        </div>
                    </div>
                </a>
            </div>`
        }
    })

    document.getElementById("districts_list").innerHTML = districts_list

    document.getElementById(
        "list_districts"
    ).innerHTML = `Districts (${districts.length})`
    length = districts.length

    if (window.innerWidth > 991)
        $("#save-my-voting-precinct").removeClass("hidden")
    document.getElementById("list_districts").style.display = "block"

    document.getElementById("election-overview-div").style.visibility =
        "visible"
}

function getGroupByResult(elections) {
    let groupedElections = elections.reduce(function (acc, cur) {
        if (cur.subdistricted == "1") {
            var key = cur.state_id + "-" + Math.random().toString(36).substr(2, 9) + cur.subdistricted
        } else {

            if (cur.city_id) {
                var key = cur.state_id + "-" + "city-" + cur.city_id + "-" + cur.office_title + cur.subdistricted;
            } else if (cur.county_id) {
                var key = cur.state_id + "-" + "county-" + cur.county_id + "-" + cur.office_title + cur.subdistricted;
            } else {
                var key = cur.state_id + "-" + "county-" + cur.county_id + "-city-" + cur.city_id + "-" + cur.office_title + cur.subdistricted;
            }
        }

        console.log("key", key)

        if (!acc[key]) {
            acc[key] = cur;
            acc[key].election_ids = []
        }

        acc[key].election_ids.push(cur.election_id);

        return acc;
    }, {});

    return Object.values(groupedElections);
}

function getLinkForElection(election) {
    if (election.subdistricted == "0" && election.election_ids)
        return `/pages/election-candidates/index.php?election_ids=${
            election.election_ids
        }`;
    else
        return `/pages/election-candidates/index.php?election_id=${
            election.election_id
        }`;

}

function renderElections(list) {
    elections = getGroupByResult(list)

    // elections = list
    // let federal_count = 0
    // let state_count = 0
    // let local_count = 0
    // let all_count = 0
    let all_election_dates = [];

    elections.sort((a, b) => {
        return b.district_order - a.district_order
    })
    let elections_list = ""
    console.log(elections)
    elections.map((election, index) => {
        // if (election.government_level === "Federal") {
        //     federal_count++
        // } else if (election.government_level === "State") {
        //     state_count++
        // } else {
        //     local_count++
        // }
        // all_count++
        all_election_dates.push(election.election_date)
        if (window.innerWidth < 991) {
            // elections_list += `<div class="election-item ${
            //     !index ? "slick-center" : ""
            // }"  data-index="${index}" data-district="${election.district_id}">
            //     <div class="ballot-row-2 election_candidate_a" >
            //         <div class="img-election-type">
            //             ${getGovernmentLevelImg(election.government_level)}
            //         </div>
            //         <div class="w-100p">
            //             <p class="election-name-cls">${getOfficeTitle(election)}</p>
            //             <div class="election-date">
            //                 <div class="election-type">
            //                     <p class = "election-label-gray">Election Type</p>
            //                     <p class="text-left">${
            //                         election.election_type
            //                     }</p>
            //                 </div>
            //                 <div class="el-second-bar">
            //                     <p class = "election-label-gray show">Election Date</p>
            //                     <p class="text-left">${
            //                         election.election_date
            //                     }</p>
            //                 </div>
            //             </div>
            //         </div>
            //     </div>
            //     <div class="election-link" data-index="${index}" data-subdistricted="${election.subdistricted}" data-elections="${election.election_ids}" data-location="${election.location_id}" data-href="${getLinkForElection(election)}">Select<img src="/assets/arrow-right.svg"></div>
            // </div>`
        } else {
            // elections_list += `<li>
            //     <a  href="${getLinkForElection(election)}" class="ballot-row-2 election_candidate_a" data-subdistricted="${election.subdistricted}" data-elections="${election.election_ids}" data-district="${
            //     election.district_id
            // }" data-location="${election.location_id}">
            //         <div class="img-election-type">
            //             ${getGovernmentLevelImg(election.government_level)}
            //         </div>
            //         <div class="w-100p">
            //             <p class="election-name-cls">${getOfficeTitle(election)}</p>
            //             <div class="election-date">
            //                 <div class="election-type">
            //                     <p class = "election-label-gray">Election Type</p>
            //                     <p class="text-left">${
            //                         election.election_type
            //                     }</p>
            //                 </div>
            //                 <div class="el-second-bar">
            //                     <p class = "election-label-gray show">Election Date</p>
            //                     <p class="text-left">${
            //                         election.election_date
            //                     }</p>
            //                 </div>
            //             </div>
            //         </div>
            //     </a>
            // </li>`

            document.getElementById("elections_list").innerHTML = elections_list
        }
    })

    console.log("all_election_dates", all_election_dates)
    // document.getElementById("all_el_count").innerHTML = all_count ?? 0
    // document.getElementById("all_el_count_mobile").innerHTML = "(" + [...new Set(all_election_dates)].length + ")"
    // document.getElementById("federal_el_count").innerHTML = federal_count ?? 0
    // document.getElementById("state_el_count").innerHTML = state_count ?? 0
    // document.getElementById("local_el_count").innerHTML = local_count ?? 0
}

const getOfficeTitle = (election) => {
    if (election.subdistricted) {
        // return election.office_title + (election.division? ' (' + election.division + ')': '')
        return election.office_title
    } else {
        return election.office_title + ' <span class="r3-block r3-w-full r3-text-xs">(' + (election.district ?? '') + ' ' + (election.division ?? '') + ')</span>'
    }
}
let response_elections = [];
let response_blank_elections = [];

/**
 * @typedef {signal?: AbortSignal} GetElectionByVotingDistrictIDsOptions
 */
/**
 *
 * @param {*} new_geo_ids
 * @param {GetElectionByVotingDistrictIDsOptions} [options]
 * @returns
 */
async function getElectionByVotingDistrictIDs(new_geo_ids = null, options) {
    /**
     * @type {AbortSignal | undefined}
     */
    let signal
    if (options !== undefined) {
        ;({signal} = options)
    }
    election_data_loaded = false
    if (new_geo_ids) {
        selected_geo_ids = new_geo_ids
    }
    console.log("geo_ids", new_geo_ids)

    const geo_ids = new_geo_ids ?? selected_geo_ids

    let response
    try {
        response = await fetch(
            `${apiHost}/elections?district_id=${geo_ids}&start_date=${start_date}&end_date=${end_date}&type=${election_type}&require_candidates=1&include_blank=1`, {signal}
        )
    } catch (err) {
        console.warn({err}, 'fetch election rejected')
        return
    }


    const data = await response.json()

    if (signal && signal.aborted) {
        console.warn('aborted while interpreting response as json')
        return
    }

    console.log(data.payload)
    election_data_loaded = true
    if (data.status === 200) {
        if (data.payload) {
            const totalElections = [...data.payload?.elections]

            response_elections = data.payload?.elections;
            response_blank_elections = data.payload?.blank_elections;

            if(response_elections.length){
                response_elections.forEach((election) => {
                    response_blank_elections.findIndex((blank_election) =>
                        blank_election.election_date == election.election_date &&
                        blank_election.government_level_id == election.government_level_id &&
                        blank_election.election_type_id == election.election_type_id
                    ) === -1 && response_blank_elections.push({
                        id: "fake-" + election.election_id,
                        election_date: election.election_date,
                        election_name: election.government_level + " " + election.election_type + " Election",
                        election_type_id: election.election_type_id,
                        government_level: election.government_level,
                        government_level_id: election.government_level_id,
                        election_month: election.election_month,
                        election_type: election.election_type,
                        state_id: election.state_id,
                        state_name: election.state_name
                    });
                });
            }

            // let totalElections = [...data.payload, ...upperLevelElections];
            if (totalElections.length) {
                renderElections(totalElections)
                document.getElementById("list_elections").classList.remove("no-elections")
            } else {

                // document.getElementById("all_el_count").innerHTML = 0
                // document.getElementById("all_el_count_mobile").innerHTML = 0
                // document.getElementById("federal_el_count").innerHTML = 0
                // document.getElementById("state_el_count").innerHTML = 0
                // document.getElementById("local_el_count").innerHTML = 0

                if (!data.payload?.blank_elections.length) {
                    if (window.innerWidth > 991) {
                        const year = (election_filter === "upcoming" ||  election_filter === "past")? "2025" : election_filter
                        document.getElementById(
                            "elections_list"
                        ).innerHTML = `<div class="light-gray" style="padding:5px;font-size:16px;">This district does not have any elections in ${year}. We will add your 2026 elections as soon as they are available.<div style="margin-top:14px; text-align:center;"><img src="/img/view-next.svg" style="width:22px;margin:auto;"/></div></div>`
                    } else {
                        document.getElementById("list_elections").classList.add("no-elections")
                    }
                    // if (window.innerWidth < 991) $("#elections_list").hide()
                }
            }
            if (data.payload?.blank_elections.length) {

                if (window.innerWidth < 991) {

                    //         blank_election_div =  `<div class="election-item"  data-index="${totalElections.length}" >
                    //     <div class="ballot-row-2 election_candidate_a" data-blank="1">
                    //         <div class="img-election-type">
                    //             ${getGovernmentLevelImg("r3")}
                    //         </div>
                    //         <div class="w-100p">
                    //             <p class="election-name-cls">Upcoming Election</p>
                    //             <div class="election-date">
                    //                 <div class="election-type">
                    //                     <p class = "election-label-gray">Election Type</p>
                    //                     <p class="text-left">Unknown</p>
                    //                 </div>
                    //                 <div class="el-second-bar">
                    //                     <p class = "election-label-gray show">Election Date</p>
                    //                     <p class="text-left">${
                    //             data.payload?.blank_elections?.date
                    //         }</p>
                    //                 </div>
                    //             </div>
                    //         </div>
                    //     </div>
                    //     <div class="election-link" data-index="${totalElections.length}" data-blank="1">Select<img src="/assets/arrow-right.svg"></div>
                    // </div>`
                } else {
                    if (!totalElections.length) {
                        document.getElementById(
                            "elections_list"
                        ).innerHTML = ``
                    }

                    let blank_election_div = '';

                    let blank_elections_by_date = data.payload?.blank_elections || [];

// Sort by election_date
                    blank_elections_by_date.sort((a, b) => new Date(a.election_date) - new Date(b.election_date));

// Group by election_date
                    let groupedElections = blank_elections_by_date.reduce((groups, election) => {
                        let date = election.election_date;
                        if (!groups[date]) {
                            groups[date] = [];
                        }
                        groups[date].push(election);
                        return groups;
                    }, {});

                    console.log("groupedElections", groupedElections)
                    console.log("blank_elections", data.payload?.blank_elections)

                    Object.entries(groupedElections).forEach(([date, elections], index) => {

                            blank_election_div += `<div class="r3-py-3"><details class="r3-group" ${index === 0 ? 'open' : ''}>
                        <summary class="r3-flex r3-justify-between r3-items-center r3-font-medium r3-cursor-pointer r3-list-none">
                                ${date}
                            <span class="r3-transition group-open:r3-rotate-180">
                <svg fill="none" height="24" shape-rendering="geometricPrecision" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" viewBox="0 0 24 24" width="24"><path d="M6 9l6 6 6-6"></path></svg></span></summary><div>`;

                            elections.map((blank_election, index) => {

                                blank_election_div += `<li>
                                <a  href="#" class="ballot-row-2 election_candidate_a" data-blank="1" data-date="${blank_election.election_date ? blank_election.election_date : ''}" data-id="${blank_election.id}">
                                    <div class="img-election-type">
                                        ${getGovernmentLevelImg("r3")}
                                    </div>
                                    <div class="w-100p">
                                        <p class="election-name-cls">${blank_election.election_name ?? 'Upcoming Election'}</p>
                                        <div class="election-date">
                                            <div class="election-type">
                                                <p class = "election-label-gray">Election Type</p>
                                                <p class="text-left">${blank_election.election_type ?? 'Unknown'}</p>
                                            </div>
                                            <div class="el-second-bar">
                                                <p class = "election-label-gray show">Election Date</p>
                                                <p class="text-left">${
                                                blank_election.election_date
                                            }</p>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </li>`
                            })

                        blank_election_div += `</div></details></div>`;


                })




                    $("#elections_list").prepend(blank_election_div)
                }
                //
                // document.getElementById("all_el_count").innerHTML = data.payload?.blank_elections.length
                // document.getElementById("all_el_count_mobile").innerHTML = data.payload?.blank_elections.length
            }
            dispatchFooterChangeEvent()
        }
    }
    $("#trans_screen_loading").hide();
    $("#map .marker").removeClass("!r3-hidden");
    $("#map .maplibregl-popup").removeClass("!r3-hidden");
}

function initPage() {
    // Add left and bottom panels
    /// //////////////////////
    // Add ballot boxes
    /// //////////////////////

    // Initialize
    const url = new URL(window.location)
    const ballotRow = document.querySelector(".ballot-row")
    const electionsOverview = document.querySelector(".elections-overview")
    const ballotBoxes = new BallotBoxPanel(ballotRow)
    ballotBoxes.setElectionsOverviewDiv(electionsOverview)
    // Election Filter
    $("#election_filter_dropdown").hide()

    // Update ballot boxes
    const state = url.searchParams.get("state")
    const abbr = STATE_FIPS_BY_NAME[state].abbr
    // const params = {
    //     state: state,
    //     abbr: abbr,
    // };
    // if(p_type === 'zip')
    // {
    //     params.zip = p_value
    // }else if(p_type === 'place')
    // {
    //     params.city = p_value;
    // }else if(p_type === 'county')
    // {
    //     params.county = p_value;
    // }else if(p_type === 'state')
    // {
    //     params.state = p_value;
    // }
    //
    // ballotBoxes.update(params);

    /// //////////////////////
    // End adding ballot boxes
    /// //////////////////////

    /// //////////////////////
    // Add bottom bar
    /// //////////////////////

    addCountyList(abbr, state, true).then(() => {
        const urlCounty = url.searchParams.get("county")
        const buttons = document.querySelectorAll(".county_list li")
        let countyName
        // Find the button with the correct county in its href
        const button = Array.from(buttons).find((element) => {
            const a = element.querySelector("a")
            const href = new URL(a.href)
            const buttonCounty = href.searchParams.get("fips")
            const buttonId = element.id
            if (buttonCounty === urlCounty || buttonId === urlCounty)
                countyName = buttonId
            return buttonCounty === urlCounty || buttonId === urlCounty
        })

        // Highlight the button
        if (!button) return

        if (countyName) $(".county-name").text(countyName + " County")
        button.classList.add("selected")

        // Scroll to the button
        const rect = button.getBoundingClientRect()
        const position = (rect.left + rect.right) / 2 - window.innerWidth / 2
        document
            .querySelector(".county_list ul")
            .scroll({left: position, behavior: "smooth"})
        /// //////////////////////
        // Add tutorial
        /// //////////////////////

        const help = document.querySelector(".how-it-works-mini")
        // tutorial = new OSMTutorial()
        // help.style.bottom = "-180px";
        new FooterGlue(help, window.innerWidth - 56).fixOSMPage()

        /// //////////////////////
        // End adding tutorial
        /// //////////////////////

        dispatchFooterChangeEvent()
    })

    /// //////////////////////
    // End adding bottom bar
    /// //////////////////////

    // Set left panel text
    document.querySelector(".state_list ul li span").innerText = state
    // if (window.innerWidth <=600 ) {
    //     const districtsHeight = window.innerHeight * 5 / 3 - 406
    //     $('#districts_list').css({ "maxHeight": districtsHeight + 'px' })

    //     const electionsHeight = window.innerHeight - 290 * 0.6 - 70
    //     $('#elections_list').css({ "maxHeight": electionsHeight + 'px' })
    // }
}
